import isEmpty from 'lodash/isEmpty';
import {computed, watch} from 'vue';
import store from '@/store';

export function useIsTranslationLoaded(callback) {
  const isTranslationLoaded = computed(() => {
    return !isEmpty(window.VueI18n.messages[store.state.backend.language]);
  });

  watch(
    isTranslationLoaded,
    (value) => {
      if (value) callback();
    },
    {immediate: true}
  );
}
